




















import Vue from "vue";
import Component from "vue-class-component";
import UserTable from "../tables/UserTable.vue";

@Component({
  components: {
    UserTable,
  },
})
export default class ManageUsersDialog extends Vue {
  dialog: boolean = false;
}
